/**
 * Bluetooth Provider Factory
 * 
 * 플랫폼에 따라 적절한 Bluetooth Provider 를 생성합니다.
 * 
 * - Web: navigator.bluetooth (Web Bluetooth API)
 * - iOS/Android: Capacitor BLE Plugin (CoreBluetooth / Android BLE)
 */

import type { BluetoothProvider } from './BluetoothProvider';

let _provider: BluetoothProvider | null = null;

export async function getBluetoothProvider(): Promise<BluetoothProvider> {
  if (_provider) return _provider;

  // Capacitor 네이티브 플랫폼 감지
  try {
    const { Capacitor } = await import('@capacitor/core');
    if (Capacitor.isNativePlatform()) {
      const { NativeBluetoothProvider } = await import('./NativeBluetoothProvider');
      _provider = new NativeBluetoothProvider();
      console.log(`[BluetoothProvider] Native mode: ${_provider.platform}`);
      return _provider;
    }
  } catch {
    // Capacitor 미설치 환경 → Web 모드
  }

  // Web Bluetooth API
  const { WebBluetoothProvider } = await import('./WebBluetoothProvider');
  _provider = new WebBluetoothProvider();
  console.log(`[BluetoothProvider] Web mode: ${_provider.platform}`);
  return _provider;
}
